module.exports = __webpack_public_path__ + "img/top.f6521a74.png";